import React, { useState } from 'react';
import OceanEngine from 'components/widgets/engines/cruiseOcean';
import RiverEngine from 'components/widgets/engines/cruiseRiver';
import Lang from 'libraries/Lang';

const CruiseEngines = (props) => {
    const [engine, setEngine] = useState('ocean');

    return (
        <>
            <form>
                <div className="row gutter-10">
                    <div className="col-auto">
                        <div className="styled-radio black-text">
                            <input type="radio" id="cru_ocean" name="trip" value="ocean" onChange={() => { setEngine('ocean'); }} checked={engine === 'ocean'} />
                            <label htmlFor="cru_ocean"><span>{Lang.trans('engine_cruises.ocean')}</span></label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="cru_river" name="trip" value="river" onChange={() => { setEngine('river'); }} checked={engine === 'river'} />
                            <label htmlFor="cru_river"><span>{Lang.trans('engine_cruises.river')}</span></label>
                        </div>
                    </div>
                </div>
            </form>
            <div className={`${engine !== 'ocean' ? 'd-none' : ''}`}>
                <OceanEngine commonDateFormat={props.commonDateFormat} />
            </div>
            <div className={`${engine !== 'river' ? 'd-none' : ''}`}>
                <RiverEngine commonDateFormat={props.commonDateFormat} />
            </div>
        </>
    );
};

export default CruiseEngines;
